import jsPDF from 'jspdf';
import 'jspdf-autotable';


const generatePDF = (selectedItem) => {
    const { customerId, invocieDate, invoiceNum } = selectedItem[0];

    const doc = new jsPDF();
    // Add header
    doc.setFontSize(15);
    doc.text('ABHYUDAYA AGENCIES', 14, 10).setFont('undefined', 'bold');
    doc.setFontSize(7).setFont('undefined', 'normal');
    doc.text('ABHYUDAYA AGENCIES,Flat No HNo44-138, A / 2 Sy No138,Badangpet', 14, 15);
    doc.text('Telangana, 500058', 14, 19);
    doc.text('Phone no. : 9030368225', 14, 23);
    doc.text('PAN no. : ACLFA5677J', 14, 27);
    doc.text('GSTIN : 36ACLFA5677J1ZU', 14, 31);
    doc.text('State: 36-TELANGANA', 14, 35);

    // Add invoice title
    doc.setFontSize(16).setFont('undefined', 'bold');
    doc.text('TAX INVOICE', 105, 40, null, null, 'center').setFont('undefined', 'normal');

    // Add customer name and invoice number
    doc.setFontSize(8);
    doc.setFont('undefined', 'bold');
    doc.text(`Order Details`, 14, 50);
    doc.setFont('undefined', 'normal');
    doc.text(`Order No.: ${invoiceNum}`, 14, 55);
    doc.text(`Date: ${invocieDate}`, 14, 58);
    doc.text(`Place of supply: 36-TELANGANA`, 14, 62);
    doc.text(`Due date: ${invocieDate}`, 14, 65);

    // Add customer address details aligned to the right
    const rightAlignX = doc.internal.pageSize.width - 14;
    const addressLines = doc.splitTextToSize(`${customerId.address}`, 78);
    const addressLineHeight = 4;
    doc.setFont('undefined', 'bold');
    doc.text(`Order From`, rightAlignX, 50, { align: 'right' });
    doc.text(`${customerId.customerName}`, rightAlignX, 55, { align: 'right' });
    doc.setFont('undefined', 'normal')
    doc.text(addressLines, rightAlignX, 59, { align: 'right' });
    const customerDetailsY = 59 + (addressLines.length * addressLineHeight);
    doc.text(`Hyderabad`, rightAlignX, customerDetailsY, { align: 'right' });
    doc.text(`GSTIN:${customerId.gstNumber}`, rightAlignX, customerDetailsY + 4, { align: 'right' });
    doc.text(`State:36-TELANGANA`, rightAlignX, customerDetailsY + 8, { align: 'right' });
    const tableStartY = Math.max(75, customerDetailsY + 13);

    // Add table
    const tableData = selectedItem.map(item => [
        item.name,
        item.mrp,
        item.quantity,
        `${item.unitprice.toFixed(2)}`,
        `${(item.unit === 'Box' ? item.quantity * item.baseUnitGst : item.quantity * item.secondaryUnitGst).toFixed(2)}`,
        `${(item.quantity * item.unitprice).toFixed(2)}`,
    ]);
    const totalItems = selectedItem.reduce((acc, item) => acc + parseInt(item.quantity), 0);
    const totalPrice = selectedItem.reduce((acc, item) => acc + (item.quantity * item.unitprice), 0);

    doc.autoTable({
        startY: tableStartY,
        head: [['Product Name', 'MRP', 'Cs Quantity', 'Base Rate', 'GST', 'Net Value']],
        body: [
            ...tableData,
            [{ content: 'Total' }, '', totalItems, '', '', `${totalPrice.toFixed(2)}`]
        ],
        theme: 'striped',
        headStyles: { fillColor: [8, 47, 114] },
        styles: { halign: 'center', fontSize: 8 },
    });

    // Add company seal place
    doc.setFontSize(12);
    doc.text('For:ABHYUDAYA AGENCIES', rightAlignX, doc.autoTable.previous.finalY + 20, { align: 'right' });
    doc.setFont('undefined', 'bold');
    doc.text('Authorized Signatory', rightAlignX, doc.autoTable.previous.finalY + 40, { align: 'right' });
    doc.setFont('undefined', 'normal');
    // Add footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.width - 20, doc.internal.pageSize.height - 10, { align: 'right' });
    }
    doc.save(`${invoiceNum}_invoice.pdf`);
};

export default generatePDF;


// WEBPACK FOOTER //
// ./src/components/CustomComponents/GeneratePDF.js